import React from 'react'
import styles from './pricingheader.module.css'

const PricingHeader = ({ children }) => {
  return <div className={styles.pricingplanheader}>{children}</div>
}

export default PricingHeader
